import { Component, OnInit, ChangeDetectionStrategy, Input, Output, OnDestroy, EventEmitter } from '@angular/core';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { TranslateHelperService } from '@common/modules/translation/services/translate-helper.service';
import { ONLINE_SERVICES_TERMS } from '@common/modules/shared/links';
import { envTypes } from '@common/modules/api/interfaces';
import { UtilsService } from '@common/modules/shared/services/utils.service';

import { CoreStoreService } from '../../../../../apps/web/src/core/services/core-store.service';
import { resources } from './resources';

@Component({
  selector: 'app-vi-upload-consent',
  templateUrl: './upload-consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./upload-consent.component.scss'],
  standalone: false
})
export class UploadConsentComponent implements OnInit, OnDestroy {
  public resources = resources;
  public isUSAccount = false;

  @Input() public disabled = false;
  @Input() public isUserConfirmTerms = false;
  @Output() public toggleFunc = new EventEmitter();

  private isTrial = false;
  private destroy$ = new Subject<void>();

  constructor(private translate: TranslateHelperService, private coreStore: CoreStoreService, private utilService: UtilsService) {}

  public ngOnInit(): void {
    this.coreStore.coreMetadataLoaded$.pipe(takeUntil(this.destroy$)).subscribe(isLoaded => {
      if (isLoaded) {
        this.addDataListeners();
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public toggleConfirmTerms($event) {
    this.isUserConfirmTerms = !this.isUserConfirmTerms;
    this.toggleFunc.emit($event);
  }

  private addDataListeners() {
    this.coreStore.selectedUIAccount$.pipe(takeUntil(this.destroy$)).subscribe(account => {
      this.isTrial = account.accountType === envTypes.TRIAL;
      this.isUSAccount = this.utilService.isAccountOnUSDataCenter(account.location, this.isTrial);
      this.translateConsent();
    });
  }

  private translateConsent() {
    this.translate.translateResources(this.resources, {
      documentationLink: ONLINE_SERVICES_TERMS,
      documentationTitle: this.resources.UploadOnlineServicesTerms,
      serviceAgreementLink: this.getServiceAgreementLink(),
      serviceAgreementTitle: this.resources.UploadServiceAgreement,
      privacyStatementLink: this.getPrivacyStatementLink(),
      privacyStatementTitle: this.resources.UploadPrivacyStatement
    });
  }

  private getServiceAgreementLink(): string {
    return this.utilService.getLinkByValue(this.isTrial, 'ServiceAgreement');
  }

  private getPrivacyStatementLink(): string {
    return this.utilService.getLinkByValue(this.isTrial, 'PrivacyStatement');
  }
}
